function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context('@projectImages/icons', true, /\.svg$/));

// import '../../images/icons/icon--acco-gift-vouch.svg';
// import '../../images/icons/icon--acco-my-details.svg';
// import '../../images/icons/icon--acco-payment.svg';
// import '../../images/icons/icon--add-blue.svg';
// import '../../images/icons/icon--adren-tubing.svg';
// import '../../images/icons/icon--arrow-down.svg';
// import '../../images/icons/icon--basket.svg';
// import '../../images/icons/icon--basket-empty.svg';
// import '../../images/icons/icon--bed.svg';
// import '../../images/icons/icon--birthday.svg';
// import '../../images/icons/icon--calendar.svg';
// import '../../images/icons/icon--calendar-blue.svg';
// import '../../images/icons/icon--calendar-small.svg';
// import '../../images/icons/icon--carousel.svg';
// import '../../images/icons/icon--chevron.svg';
// import '../../images/icons/icon--chevron-dark-grey.svg';
// import '../../images/icons/icon--chevron-down.svg';
// import '../../images/icons/icon--chevron-grey.svg';
// import '../../images/icons/icon--chevron-left.svg';
// import '../../images/icons/icon--chevron-right.svg';
// import '../../images/icons/icon--chevron-up.svg';
// import '../../images/icons/icon--chevron-new.svg';
// import '../../images/icons/icon--chevron-down-new.svg';
// import '../../images/icons/icon--circle-tick.svg';
// import '../../images/icons/icon--climbing.svg';
// import '../../images/icons/icon--clock.svg';
// import '../../images/icons/icon--clock-small.svg';
// import '../../images/icons/icon--close-delete-x.svg';
// import '../../images/icons/icon--coaching.svg';
// import '../../images/icons/icon--contact-us.svg';
// import '../../images/icons/icon--corporate.svg';
// import '../../images/icons/icon--customer-service.svg';
// import '../../images/icons/icon--datepicker-arrow-blue.svg';
// import '../../images/icons/icon--datepicker-arrow-grey.svg';
// import '../../images/icons/icon--day-ticket.svg';
// import '../../images/icons/icon--deals.svg';
// import '../../images/icons/icon--directdebit.svg';
// import '../../images/icons/icon--email-signup.svg';
// import '../../images/icons/icon--events.svg';
// import '../../images/icons/icon--explore.svg';
// import '../../images/icons/icon--filtering.svg';
// import '../../images/icons/icon--fitness.svg';
// import '../../images/icons/icon--food.svg';
// import '../../images/icons/icon--freestyle.svg';
// import '../../images/icons/icon--gift.svg';
// import '../../images/icons/icon--groups.svg';
// import '../../images/icons/icon--groups-fixed.svg';
// import '../../images/icons/icon--groups-fixed-small.svg';
// import '../../images/icons/icon--info.svg';
// import '../../images/icons/icon--info-small.svg';
// import '../../images/icons/icon--junior-tubing.svg';
// import '../../images/icons/icon--leisure-chinup.svg';
// import '../../images/icons/icon--leisure-cycling.svg';
// import '../../images/icons/icon--leisure-legday.svg';
// import '../../images/icons/icon--leisure-shower.svg';
// import '../../images/icons/icon--leisure-stretch.svg';
// import '../../images/icons/icon--leisure-swim.svg';
// import '../../images/icons/icon--leisure-tick.svg';
// import '../../images/icons/icon--leisure-treadmill.svg';
// import '../../images/icons/icon--leisure-weights.svg';
// import '../../images/icons/icon--lesson.svg';
// import '../../images/icons/icon--map-marker.svg';
// import '../../images/icons/icon--membership.svg';
// import '../../images/icons/icon--memberships.svg';
// import '../../images/icons/icon--menu.svg';
// import '../../images/icons/icon--minus.svg';
// import '../../images/icons/icon--my-account.svg';
// import '../../images/icons/icon--news.svg';
// import '../../images/icons/icon--offer.svg';
// import '../../images/icons/icon--payment.svg';
// import '../../images/icons/icon--plus.svg';
// import '../../images/icons/icon--pound-small.svg';
// import '../../images/icons/icon--price-tag.svg';
// import '../../images/icons/icon--price-tag-small.svg';
// import '../../images/icons/icon--profile.svg';
// import '../../images/icons/icon--quickbook.svg';
// import '../../images/icons/icon--santa-reindeer.svg';
// import '../../images/icons/icon--santa-show.svg';
// import '../../images/icons/icon--santa-trail.svg';
// import '../../images/icons/icon--schools.svg';
// import '../../images/icons/icon--shop.svg';
// import '../../images/icons/icon--skating.svg';
// import '../../images/icons/icon--ski.svg';
// import '../../images/icons/icon--ski-and-snowboard.svg';
// import '../../images/icons/icon--sledging.svg';
// import '../../images/icons/icon--slider-arrow.svg';
// import '../../images/icons/icon--snowboard.svg';
// import '../../images/icons/icon--snowflake.svg';
// import '../../images/icons/icon--snowflake-loading.svg';
// import '../../images/icons/icon--snowflake-loading-alt.svg';
// import '../../images/icons/icon--snowfun.svg';
// import '../../images/icons/icon--sofa-slope-mapmarker.svg';
// import '../../images/icons/icon--spa.svg';
// import '../../images/icons/icon--star-full.svg';
// import '../../images/icons/icon--star-half.svg';
// import '../../images/icons/icon--star-empty.svg';
// import '../../images/icons/icon--subtract-blue.svg';
// import '../../images/icons/icon--swimming.svg';
// import '../../images/icons/icon--terms.svg';
// import '../../images/icons/icon--terms-condish.svg';
// import '../../images/icons/icon--thumb-up.svg';
// import '../../images/icons/icon--ticket.svg';
// import '../../images/icons/icon--ticket-day.svg';
// import '../../images/icons/icon--tiktok.svg';
// import '../../images/icons/icon--tiny-tubing.svg';
// import '../../images/icons/icon--tooltip-close.svg';
// import '../../images/icons/icon--triangle.svg';
// import '../../images/icons/icon--wear-boots.svg';
// import '../../images/icons/icon--wear-flops.svg';
// import '../../images/icons/icon--wear-heels.svg';
// import '../../images/icons/icon--wear-jeans.svg';
// import '../../images/icons/icon--wear-non-wooly-gloves.svg';
// import '../../images/icons/icon--wear-trackies.svg';
// import '../../images/icons/icon--wear-tshorts.svg';
// import '../../images/icons/icon--wear-warm-clothes.svg';
// import '../../images/icons/icon--wear-wooly-gloves.svg';
// import '../../images/icons/icon--wear-wooly-hat-gloves.svg';
// import '../../images/icons/icon--what.svg';
// import '../../images/icons/icon--what-small.svg';
// import '../../images/icons/icon--what-to-wear.svg';
// import '../../images/icons/icon--wheelchair.svg';
// import '../../images/icons/icon--winter-wonderland.svg';
// import '../../images/icons/icon--wtw-hairdown.svg';
// import '../../images/icons/icon--wtw-jewellery.svg';
// import '../../images/icons/icon--wtw-ponytail.svg';
// import '../../images/icons/icon--wtw-trackies.svg';
// import '../../images/icons/icon--wtw-trainers.svg';
// import '../../images/icons/icon--youtube.svg';
// import '../../images/icons/icon--twitter.svg';
// import '../../images/icons/icon--instagram.svg';
// import '../../images/icons/icon--facebook.svg';
// import '../../images/icons/icon--new-calendar.svg';
// import '../../images/icons/icon--gloves.svg';
// import '../../images/icons/splash-header.svg';
// import '../../images/icons/splash-body.svg';
// import '../../images/icons/splash-trim.svg';
